// Typography
import { ValueOf } from "@shared/types/utils";

const pxFontSizes = Object.freeze({
  XXXL: 50,
  XXL: 32,
  XL: 18,
  L: 16,
  M: 14,
  S: 12,
  XS: 10,
} as const);

export type FontSizesPixels = typeof pxFontSizes;
export type FontSizesPixelsStrings = {
  [K in keyof FontSizesPixels]: `${FontSizesPixels[K]}px`;
};
export type PxFontSize = keyof FontSizesPixels;
export type FontSizesValue = ValueOf<FontSizesPixelsStrings>;

const fontSizes = Object.entries(pxFontSizes).reduce((acc, [key, val]) => {
  //@ts-ignore
  acc[key] = val + "px";
  return acc;
}, {}) as FontSizesPixelsStrings;

const fontWeights = Object.freeze({
  NORMAL: 400,
  MEDIUM: 500,
  SEMI_BOLD: 600,
  BOLD: 700,
  EXTRA_BOLD: 800,
} as const);

export type FontWeightValue = ValueOf<typeof fontWeights>;

export const typography = {
  fontFamily:
    "NunitoSans, Inter,-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n" +
    "    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n" +
    "    sans-serif",
  fontSizes,
  pxFontSizes,
  fontWeights,
};
